import React from 'react';
import { getCurrentUser } from '../../../../services/authService';
import RedirectToLogin from '../../../../utils/RedirectToLogin';
import logo from "../../../../assets/cms-logo.svg";

function ReportPayroll(props) {
  const { generateReportConfirmation, reportContext, reportsContext, handleGenerateReport } = props;

  return (
    !getCurrentUser()
      ? <RedirectToLogin location={reportsContext.props.location} />
      : <section className="ReportToolFiltersConfirmation" role="alert">
          <div className="ReportResults">
            <div className="ReportResults-body">
              <div className="row justify-content-center">
                <div className="col-sm-11">
                  <div className="ReportResults-info d-flex align-items-start">
                    <div className="col-8 sub-title">
                      <h3>{reportContext.reportData.name}</h3>
                      <p>
                        {generateReportConfirmation.filters.deparmentFiltered}&nbsp;/&nbsp;
                        {generateReportConfirmation.filters.datesFiltered}
                      </p>
                    </div>
                    <div className="col-4 text-right p-0">
                      <img className="cms-logo img-fluid" src={logo} width="100px" alt={ process.env.REACT_APP_NAME } />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="row">
                      <div className="col-12">
                        <h5 className="ReportToolFiltersConfirmation-message">{generateReportConfirmation.summary.message}</h5>
                        <>
                          {generateReportConfirmation.summary.message_confirmation &&
                            <div className="ReportToolFiltersConfirmation-message-confirmation">
                              <p dangerouslySetInnerHTML={{ __html: generateReportConfirmation.summary.message_confirmation }} />
                              <button className="btn btn-success"
                                onClick={() => handleGenerateReport(true)}
                              >Export</button>
                            </div>
                          }
                          { generateReportConfirmation.summary.events && generateReportConfirmation.summary.events.length !== 0 &&
                            <section className="ReportToolFiltersConfirmation-badge-wrapper">
                              <h4 className="sub-title">Events</h4>
                              <div className="row header">
                                <div className="col-5 name">
                                  Event Name
                                </div>
                                <div className="col">
                                  Shifts
                                </div>
                                <div className="col">
                                  Total Hours
                                </div>
                                <div className="col">
                                </div>
                              </div>

                              {generateReportConfirmation.summary.events.map((item, idx) => (
                                <div className="row" key={idx}>
                                  <div className="col-5 name">
                                    {item.name}
                                  </div>
                                  <div className="col">
                                    {item.staff}
                                  </div>
                                  <div className="col">
                                    {item.hours}
                                  </div>
                                  <div className="col button">
                                    <a href={'/events/' + item.id} target="_blank" rel="noopener noreferrer" title="Open in a new tab">
                                      <i className="fas fa-external-link-alt external-link-alt-custom-small"></i>
                                    </a>
                                  </div>
                                </div>
                            ))}
                            </section>
                          }

                          { generateReportConfirmation.summary.preview && generateReportConfirmation.summary.preview.length !== 0 &&
                            <section className="ReportToolPreviewConfirmation-badge-wrapper">
                              <h4 className="sub-title">Shifts</h4>
                              <div className="row header">
                                <div className="col paycom">
                                  Paycom ID
                                </div>
                                <div className="col-3 name">
                                  Name
                                </div>
                                <div className="col-3 event">
                                  Event
                                </div>
                                <div className="col">
                                  Pay Rate
                                </div>
                                <div className="col">
                                  Hours
                                </div>
                                <div className="col-2">
                                  Date
                                </div>
                                <div className="col">
                                  Reconciled
                                </div>
                              </div>

                              {generateReportConfirmation.summary.preview.map((item, idx) => (
                                <div className="row" key={idx}>
                                  <div className="col paycom">
                                    {item.paycom_id}
                                  </div>
                                  <div className="col-3 name">
                                    {item.first_name} {item.last_name}
                                  </div>
                                  <div className="col-3 event">
                                    {item.event_name}
                                  </div>
                                  <div className="col">
                                    {item.pay_rate}
                                  </div>
                                  <div className="col">
                                    {item.hours_worked}
                                  </div>
                                  <div className="col-2">
                                    {item.start_date}
                                  </div>
                                  <div className="col">
                                    {
                                      item.reconciled
                                      ? <i className="fas fa-check blueIcon"></i>
                                      : <i className="fas fa-close redIcon"></i>
                                    }
                                  </div>
                                </div>
                            ))}
                            </section>
                          }

                          { generateReportConfirmation.summary.staff && generateReportConfirmation.summary.staff.length !== 0 &&
                            <section className="ReportToolFiltersConfirmation-badge-wrapper">
                              <div className="row header">
                                <div className="col name">
                                  First Name
                                </div>
                                <div className="col">
                                  Last Name
                                </div>
                                <div className="col">
                                </div>
                              </div>

                              {generateReportConfirmation.summary.staff.map((item, idx) => (
                                <div className="row" key={idx}>
                                  <div className="col name">
                                    {item.first_name}
                                  </div>
                                  <div className="col">
                                    {item.last_name}
                                  </div>
                                  <div className="col button">
                                    <a key={idx} href={'/staff/' + item.staff_id} target="_blank" rel="noopener noreferrer" className={"badge badge-" + generateReportConfirmation.status}>Open Staff</a>
                                  </div>
                                </div>
                            ))}
                            </section>
                          }
                        </>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
  )
}

export default ReportPayroll
